module.exports = __webpack_public_path__ + "img/fde2b6cd54fec1bd010ffd31dea015b.cb6293ee.jpg";